import styled from 'styled-components';
import {alignCenter, dFlex, dFlexColumn} from '../../../../globalVariables/GlobalFlex';
import {ellipsis} from '../../../../globalVariables/GlobalVariables';

export const list = styled.div`
    ${dFlexColumn};
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 0 var(--space-lg);
`;

export const item = styled.div`
    ${dFlex};
    ${alignCenter};
    gap: var(--space-md);
    width: 100%;
    padding: var(--space-md) 0;
    border-bottom: 1px solid var(--color-border-subtle);

    &:last-child {
        border-bottom: none;
    }

    svg {
        display: block;
        /* The external-link icon points to a corner — flipped in RTL to point out of the row */
        [dir='rtl'] & {
            transform: scaleX(-1);
        }
    }
`;

export const text = styled.span`
    ${dFlexColumn};
    flex: 1;
    min-width: 0;
    gap: var(--space-2xs);
`;

export const name = styled.span`
    font-size: var(--font-size-body-small);
    font-weight: var(--font-weight-semibold);
    ${ellipsis}
`;

export const meta = styled.span`
    font-size: var(--font-size-caption);
    font-weight: var(--font-weight-regular);
    color: var(--color-text-subtle);
    ${ellipsis}
`;

export const empty = styled.p`
    padding: var(--space-xl) var(--space-lg);
    text-align: center;
    font-size: var(--font-size-body-small);
    color: var(--color-text-subtle);
`;
